/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    VerifiedOtpStatus: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.otpVerifyAction.REQUEST_VERIFY_OTP:
      return {
        ...state
      };
    case actions.otpVerifyAction.VERIFY_OTP_RECIEVED:
      return {
        ...state,
        VerifiedOtpStatus: action.data
      };
  
    default:
      return state;
  }
};

export default reducer;
